<template>
    <card>
      <div class="card-header">
        <div class="row">
          <div class="col-md-4 pr-md-1">
            <div v-if="showAttach">
              <transition name="view" appear enter-active-class="animated fadeIn delay" leave-active-class="animated fadeOut">
                <base-button class="clock-button" block size="lg" simple type="warning" @click="send">Attach</base-button>
              </transition>
            </div>
            <div v-else>
              <h2 class="title"><code class="text-warning">Upload File</code></h2>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <form id="upLoadFile" enctype="multipart/form-data" onsubmit="return false">
          <div class="row">
            <div class="col-md-4 pr-md-1" style="margin-top: -4px;">
              <base-button class="clock-button" simple block type="info" onclick="document.getElementById('chFl').click()" >Choose...
                <input id="chFl" type="file" ref="file" v-on:change="handleFileUpload" style="display: none;"/>
              </base-button>
            </div>
            <base-input class="col-md-8 px-md-1" label=""
                        v-model="file.description"
                        placeholder="description">
            </base-input>
          </div>
          <div class="row" style="margin-top: 15px">
            <div class="col-md-12 pr-md-1">
              <h5>File: {{file.file.name}}</h5>
            </div>
          </div>
        </form>
      </div>
    </card>
</template>

<script>
    export default {
      name: "add-document",
      props: [],
      data(){
        return{
          file:{file:{}, description:'', type: '', date: ''},
          showAttach: false,
        }
      },
      methods:{
        send(){
          const today = new Date();
          this.file.date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+(today.getDate()) + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
          this.$emit('send-file', this.file);
          this.file = {file:{}, description:'', type: '', date: null};
          this.showAttach = false;
          document.getElementById('chFl').value = '';

        },
        handleFileUpload(){
          this.showAttach = true;
          this.file.file = this.$refs.file.files[0];
        },
      },
    }
</script>

<style scoped>

</style>
